import React, { useMemo } from 'react';
import Office from '../../../../layouts/office/Office/Office';
import StructureView from '../../../../views/structure/StructureWrapper';
import { getLangPaths, getUserStaticProps } from '../../../api/_props';
import Language from '../../../../common/decorators/Language';
import { useWindowDimensions } from '../../../../common/utils/windowDimensions';
import { t } from '../../../../common/components/T';
import { useLayoutProps } from '../../../../common/utils/useLayoutProps';

const Structure = ({ translates, setLayoutProps }) => {
    const widthDimensions = useWindowDimensions();
    const screenWidth = widthDimensions <= 768;
    const layoutProps = useMemo(
        () => ({
            title: screenWidth
                ? t('page_title_xs', 'Структура', '/structure', translates)
                : t('page_title', 'Структура личных приглашений', '/structure', translates)
        }),
        [screenWidth, translates]
    );
    useLayoutProps(layoutProps, setLayoutProps);

    return (
        <Language page={'/structure'} translates={translates}>
            <StructureView />
        </Language>
    );
};

Structure.getLayout = function getLayout(page, pageProps, layoutProps) {
    const { translates } = pageProps;
    return (
        <Office
            title={t('page_title_new', 'Отчет «Структура по приглашениям»', '/structure', translates)}
            translates={translates}
            {...layoutProps}
            titleBlock={{
                title: t('page_title_new', 'Отчет «Структура по приглашениям»', '/structure', translates),
                text: t('page_undertitle', 'Отслеживайте информацию по всем дистрибьюторам в структуре', '/structure', translates)
            }}
        >
            {page}
        </Office>
    );
};
export async function getStaticProps({ params }) {
    return await getUserStaticProps(params, '/structure', ['/office'], 'office');
}
export async function getStaticPaths() {
    const paths = await getLangPaths();
    return {
        paths,
        fallback: true
    };
}
export default Structure;
